import { DateTimeFormatter } from '@nile/components';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import React from 'react';

function PatchDateTimeCell(props) {
  const { cell, type } = props;
  const cellOriginal = cell?.row?.original;
  let val = cellOriginal?.patchDetail
    ? cellOriginal.patchDetail?.publishedDate
    : cellOriginal?.publishedDate;
  const getType = () => {
    if (cell?.column?.onlyDate) {
      return 'date';
    }
    return 'dateTime';
  };

  return val ? (
    <DateTimeFormatter type={getType()} date={val} />
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
}

export default PatchDateTimeCell;
